import React, { useCallback, useEffect, useState } from "react";

import ImageModal from "components/ui/ImageModal";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";
import { useSettingContext } from "context/SettingContext";
import apiClient from "lib/api-client";
import { useLocation, useParams } from "react-router-dom";
import { useInfiniteQuery } from "@tanstack/react-query";
import DesignTable from "components/ui/DesignTable";

const DesignImport = () => {
  const permission = usePermissions();
  const location = useLocation();
  const { designs: time } = useParams();
  const { setSyncButtonName, setSyncButton } = useSettingContext();
  const [imageModal, setImageModal] = useState({ isOpen: false, imgUrl: null, designNo: null });
  // const hasAccessToSeeWatermark = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Other Settings", permission), "Watermark"), "vi
  const hasAccessToSeeWatermark = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Watermark"), "view") && !permission?.isAdmin;;
  const path = location.pathname.split("/")[2];

  const handleOpenImageModal = useCallback((imgUrl, designNo) => {
    setImageModal({ isOpen: true, imgUrl, designNo });
  }, []);

  const handleCloseImageModal = useCallback(() => {
    setImageModal({ isOpen: false, imgUrl: null, designNo: null });
  }, []);

  const limit = 15;

  const fetchDesigns = async ({ pageParam = 1 }) => {
    const res = await apiClient.get(`/api/v4/import_gati/getGatiImportStylesAccordingToDate`, {
      params: { date: time, page: pageParam, limit, info: path === "design-update" ? "update" : null },
    });
    return { data: res.data.getGatiImportStyles, nextPage: res.data.getGatiImportStyles.length ? pageParam + 1 : null };
  };

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery({
    queryKey: [`designs${path}`, time],
    queryFn: fetchDesigns,
    getNextPageParam: (lastPage) => lastPage.nextPage,
  });

  useEffect(() => {
    setSyncButtonName("exportDesign");
    setSyncButton(true);

    return () => {
      setSyncButtonName(null);
      setSyncButton(false);
    };
  }, []);

  return (
    <>
      <div style={{ marginTop: "15px", marginLeft: "6px", marginRight: "11.5px" }}>
        <DesignTable data={data} fetchNextPage={fetchNextPage} hasNextPage={hasNextPage} isFetchingNextPage={isFetchingNextPage} handleOpenImageModal={handleOpenImageModal} />
      </div>
      <ImageModal open={imageModal.isOpen} handleClose={handleCloseImageModal} data={imageModal} hasAccessToSeeWatermark={hasAccessToSeeWatermark} />
    </>
  );
};

export default DesignImport;
